import dayjs from "dayjs";

import { ApplicantExamModel } from "@shared/models";
import { DeliveryMethod } from "@shared/services/enums";

// Utility to check if time limit is valid
export const shouldShowTimeLimit = (
  deliveryMethod: DeliveryMethod,
  timeLimitMinutes: number,
  deadline: string,
) => {
  return (
    deliveryMethod === DeliveryMethod.URL &&
    timeLimitMinutes > 0 &&
    dayjs().add(timeLimitMinutes, "minutes").isBefore(dayjs(deadline))
  );
};

// Utility to validate form
export const isFormValidCheck = (
  webcamEnabled: boolean,
  formValid: boolean,
  applicantSegment: {
    formValid: boolean;
    formValues: {};
    formErrors?: {};
  },
  isTermAccepted: boolean,
  exam: ApplicantExamModel,
) => {
  if (webcamEnabled) {
    return formValid && applicantSegment.formValid;
  }
  return (
    formValid &&
    applicantSegment.formValid &&
    (exam.isInProgress() ? true : isTermAccepted)
  );
};
